import axios from "axios";
import { Base_URL } from "../url";

export const savePaymentDateGroup = async (groupData) => {
  try {
    const userDetails = JSON.parse(localStorage.getItem("userDetails"));
    const userId = userDetails?.userId; 
    const response = await axios.post(
      `${Base_URL}/PaymentDateGroupMaster/PaymentDateGroupMaster?UserName=${userId}`,
      groupData
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error saving Payment Date Group!";
  }
};
